import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/plan/view/license.plan.migration.upsert.mutation.gql"
import type {
  PlanMigrationUpsertMutation,
  PlanMigrationUpsertMutationVariables,
} from "@/v2-backoffice-client/license/plan/view/__types__/license.plan.migration.upsert.mutation"

type Options = MutationHookOptions<
  PlanMigrationUpsertMutation,
  PlanMigrationUpsertMutationVariables
>

export function usePlanMigrationUpsertMutation(options?: Options) {
  return useMutation<
    PlanMigrationUpsertMutation,
    PlanMigrationUpsertMutationVariables
  >(mutation, options)
}
